/* Salvona — product page: size cards, quote/sample switching, gallery, NFKC titles */
/* Salvona chart renderer: bar/line from JSON → SVG in brand style */
function photosHTML(c){
  function esc(t){return String(t).replace(/[&<>"]/g,function(m){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m];});}
  var rows=c.rows||[], cols=c.cols||[], t=c.tiles||[], W=c.w||1, H=c.h||1, k=0;
  var o='<div class="svd-ph" style="--cols:'+cols.length+'"><span></span>';
  cols.forEach(function(cl){o+='<b class="svd-ph-col">'+esc(cl)+'</b>';});
  rows.forEach(function(r,ri){
    o+='<b class="svd-ph-row'+(ri===rows.length-1&&c.highlight_last!==false?' is-salvona':'')+'">'+esc(r)+'</b>';
    cols.forEach(function(){var q=t[k++]||[0,0,100,100];var ar=(q[2]*W)/(q[3]*H);
      var bs=(10000/q[2])+'% '+(10000/q[3])+'%', bp=(q[2]>=100?0:q[0]/(100-q[2])*100)+'% '+(q[3]>=100?0:q[1]/(100-q[3])*100)+'%';
      o+='<span class="svd-ph-tile" style="aspect-ratio:'+ar.toFixed(3)+';background-image:url(\''+c.src+'\');background-size:'+bs+';background-position:'+bp+'"></span>';});
  });
  return o+'</div>';
}
function chartSVG(c){
  var W=600,H=340,L=58,R=18,T=18,B=58,pw=W-L-R,ph=H-T-B;
  var series=c.series||[], xs=c.x||[], n=xs.length, unit=c.unit||'';
  var max=c.y_max; if(!max){max=0;series.forEach(function(s){s.values.forEach(function(v){if(+v>max)max=+v;});});var p=Math.pow(10,Math.floor(Math.log10(max||1)));max=Math.ceil(max/p)*p;}
  var min=c.y_min; if(min==null){min=0;var lo=0;series.forEach(function(s){s.values.forEach(function(v){if(+v<lo)lo=+v;});});if(lo<0){var q=Math.pow(10,Math.floor(Math.log10(-lo)));min=-Math.ceil(-lo/q)*q;}}
  var ticks=c.ticks||5;
  (function(){var r=(max-min)/ticks,p=Math.pow(10,Math.floor(Math.log10(r))),f=r/p,st=(f<=1?1:f<=2?2:f<=2.5?2.5:f<=5?5:10)*p;ticks=Math.round(Math.ceil((max-min)/st-1e-9));max=min+ticks*st;})();
  function y(v){return T+ph-(v-min)/(max-min)*ph;}
  function col(s){return s.role==='salvona'?'var(--c1)':s.role==='control'?'#A9B4C6':'var(--c2)';}
  function esc(t){return String(t).replace(/[&<>"]/g,function(m){return{'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m];});}
  var o='<svg viewBox="0 0 '+W+' '+H+'" class="svd-svg" role="img" aria-label="'+esc(c.title||'Chart')+'">';
  for(var i=0;i<=ticks;i++){var v=min+(max-min)*i/ticks,yy=y(v);o+='<line class="g" x1="'+L+'" x2="'+(W-R)+'" y1="'+yy+'" y2="'+yy+'"/><text class="t" x="'+(L-10)+'" y="'+(yy+4)+'" text-anchor="end">'+(Math.round(v*10)/10)+'</text>';}
  o+='<line class="ax" x1="'+L+'" x2="'+(W-R)+'" y1="'+y(Math.max(0,min))+'" y2="'+y(Math.max(0,min))+'"/>';
  var band=pw/n;
  xs.forEach(function(x,i){o+='<text class="t" x="'+(L+band*i+band/2)+'" y="'+(T+ph+20)+'" text-anchor="middle">'+esc(x)+'</text>';});
  if(c.type==='bar'){
    var gw=band*.66, bw=gw/series.length;
    series.forEach(function(s,si){s.values.forEach(function(v,i){
      var x=L+band*i+(band-gw)/2+bw*si, y0=y(Math.max(0,min)), yy=y(+v), top=Math.min(yy,y0), h=Math.abs(y0-yy);
      o+='<rect class="bar" style="--d:'+(i*60+si*25)+'ms" x="'+(x+1)+'" y="'+top+'" width="'+(bw-2)+'" height="'+h+'" rx="3" fill="'+col(s)+'"/>';
      if(s.role==='salvona'&&i===s.values.length-1)o+='<text class="v" x="'+(x+bw/2)+'" y="'+(+v<0?yy+18:yy-8)+'" text-anchor="middle" fill="'+col(s)+'">'+(+v>0&&min<0?'+':'')+v+unit+'</text>';
    });});
  }else{
    series.forEach(function(s){
      var pts=s.values.map(function(v,i){return [L+band*i+band/2,y(+v)];});
      var d=pts.map(function(p,i){return(i?'L':'M')+p[0].toFixed(1)+' '+p[1].toFixed(1);}).join(' ');
      if(s.role==='salvona'){var a=d+' L'+pts[pts.length-1][0]+' '+(T+ph)+' L'+pts[0][0]+' '+(T+ph)+' Z';o+='<path class="area" d="'+a+'" fill="var(--c1)"/>';}
      o+='<path class="ln'+(s.role==='control'?' is-ctrl':'')+'" d="'+d+'" stroke="'+col(s)+'" pathLength="1"/>';
      pts.forEach(function(p,i){o+='<circle class="pt" style="--d:'+(i*120)+'ms" cx="'+p[0]+'" cy="'+p[1]+'" r="5" fill="#fff" stroke="'+col(s)+'"/>';});
      var lp=pts[pts.length-1];o+='<text class="v" x="'+(lp[0]+10)+'" y="'+(lp[1]+4)+'" fill="'+col(s)+'">'+s.values[s.values.length-1]+unit+'</text>';
    });
  }
  if(c.x_label)o+='<text class="lab" x="'+(L+pw/2)+'" y="'+(H-12)+'" text-anchor="middle">'+esc(c.x_label)+'</text>';
  if(c.y_label)o+='<text class="lab" transform="translate(14 '+(T+ph/2)+') rotate(-90)" text-anchor="middle">'+esc(c.y_label)+'</text>';
  return o+'</svg>';
}
(function(){
  function init(root){
    if(root.dataset.svdInit) return; root.dataset.svdInit='1';
    var dataEl=root.querySelector('[data-svd-data]'); if(!dataEl) return;
    var data=JSON.parse(dataEl.textContent);
    var fmt=new Intl.NumberFormat(undefined,{style:'currency',currency:data.currency||'USD'});
    var $=function(s){return root.querySelector(s);}, $$=function(s){return [].slice.call(root.querySelectorAll(s));};

    function kgOf(label){
      if(!label) return null;
      var s=String(label).toLowerCase().replace(/\s+/g,''), n=parseFloat(s);
      if(isNaN(n)) return null;
      if(s.indexOf('kg')>-1) return n;
      if(/(gr|g)$/.test(s)) return n/1000;
      return null;
    }
    function selected(){var g={};$$('[data-svd-opt]').forEach(function(i){if(i.checked)g[i.dataset.svdOpt]=i.value;});return g;}
    function find(sel){return data.variants.find(function(x){return x.options.every(function(o,i){return sel[i]===undefined||sel[i]===o;});});}
    function isQuote(v,kg){var p=v.price/100;var per=kg?p/kg:null;return p<=0||(kg!==null&&kg>=data.threshold)||(kg!==null&&kg>=1&&per<data.floor);}

    function paintSizes(sel){
      if(data.sizeIndex<0) return;
      $$('[data-svd-sizeprice]').forEach(function(el){
        var label=el.getAttribute('data-svd-sizeprice');
        var s=Object.assign({},sel); s[data.sizeIndex]=label;
        var v=find(s), kg=kgOf(label), card=el.closest('.svd-size'), note=root.querySelector('[data-svd-sizenote="'+CSS.escape(label)+'"]');
        if(!v){el.textContent='—';if(note)note.textContent='';return;}
        var q=isQuote(v,kg); card.classList.toggle('is-quote',q);
        if(q){el.textContent='Quote';if(note)note.textContent=kg&&kg>=data.threshold?'Volume pricing':'Request pricing';}
        else{el.textContent=fmt.format(v.price/100);if(note)note.textContent=kg&&kg>=1?fmt.format(v.price/100/kg)+'/kg':(v.available?'Sample':'Sample · on request');}
      });
    }

    function update(push){
      var sel=selected(), v=find(sel);
      var add=$('[data-svd-add]'), qb=$('[data-svd-quote]'), sb=$('[data-svd-sample]'), note=$('[data-svd-note]'), stock=$('[data-svd-stock]');
      paintSizes(sel);
      if(!v){$('[data-svd-price]').textContent='Unavailable';add.disabled=true;return;}
      $('[data-svd-id]').value=v.id;
      $$('[data-svd-sku]').forEach(function(e){e.textContent=String(v.sku).split(' ')[0];});
      var kg=data.sizeIndex>-1?kgOf(v.options[data.sizeIndex]):null, p=v.price/100, q=isQuote(v,kg);
      var sample=kg!==null&&kg<1;
      if(q){
        $('[data-svd-price]').textContent=data.hold?'Pricing on request':'Priced to your volume';
        $('[data-svd-perkg]').textContent=data.hold&&sample?Math.round(kg*1000)+' g · request a sample':(kg?kg+' kg · request a quote':'Request a quote');
      }else{
        $('[data-svd-price]').textContent=fmt.format(p);
        $('[data-svd-perkg]').textContent=kg&&kg>=1?fmt.format(p/kg)+' / kg':(kg?Math.round(kg*1000)+' g sample':'');
      }
      var out=!q&&!v.available;
      add.hidden=q||out; add.disabled=data.hold||!v.available;
      qb.hidden=data.hold?sample:(!q&&!(out&&!sample));
      sb.hidden=data.hold?!sample:!(out&&sample);
      note.hidden=q;
      root.classList.toggle('is-quote',q);
      stock.className='svd-stock'+(out?' is-out':'');
      stock.textContent=q?'':(v.available?'In stock':'Restocking');
      var g=$('[data-svd-qgrade]'); if(g) g.value=v.title;
      if(push){var u=new URL(location.href);u.searchParams.set('variant',v.id);history.replaceState({},'',u.toString());}
    }
    $$('[data-svd-opt]').forEach(function(i){i.addEventListener('change',function(){update(true);});});

    /* CTA → preselect request type in the form */
    function pick(type){var r=root.querySelector('[data-svd-rq="'+type+'"]');if(r)r.checked=true;}
    var sb=$('[data-svd-sample]'); if(sb) sb.addEventListener('click',function(){pick('sample');});
    var qb=$('[data-svd-quote]'); if(qb) qb.addEventListener('click',function(){pick('quote');});
    $$('.svd-docs-note a').forEach(function(a){a.addEventListener('click',function(){pick('docs');});});

    /* gallery */
    var main=$('.svd-main');
    $$('.svd-thumb').forEach(function(b){b.addEventListener('click',function(){
      if(!main) return; main.removeAttribute('srcset'); main.src=b.dataset.src; main.alt=b.dataset.alt;
      $$('.svd-thumb').forEach(function(x){x.classList.toggle('is-active',x===b);});
    });});

    /* native charts */
    $$('[data-svd-chart]').forEach(function(box){try{var cd=JSON.parse(box.getAttribute('data-svd-chart'));box.innerHTML=cd.type==='photos'?photosHTML(cd):chartSVG(cd);}catch(e){}});
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){if(e.isIntersecting){e.target.classList.add('is-drawn');io.unobserve(e.target);}});},{threshold:.35});
      $$('.svd-chartbox').forEach(function(b){io.observe(b);});
    }else{$$('.svd-chartbox').forEach(function(b){b.classList.add('is-drawn');});}

    /* evidence lightbox */
    var lb=$('.svd-lightbox');
    if(lb&&lb.showModal){
      var lbImg=lb.querySelector('[data-svd-lbimg]'), lbChart=lb.querySelector('[data-svd-lbchart]');
      $$('[data-svd-zoom],[data-svd-zoomchart]').forEach(function(b){b.addEventListener('click',function(){
        if(b.hasAttribute('data-svd-zoomchart')){
          var key=b.querySelector('.svd-key'), box=b.querySelector('.svd-chartbox');
          lbChart.innerHTML=(key?key.outerHTML:'')+'<span class="svd-chartbox is-drawn">'+box.innerHTML+'</span>';
          lbChart.hidden=false; lbImg.hidden=true; lbImg.removeAttribute('src');
        }else{
          lbImg.src=b.dataset.svdZoom; lbImg.hidden=false; lbChart.hidden=true; lbChart.innerHTML='';
        }
        lb.querySelector('[data-svd-lbcap]').textContent=b.dataset.svdCap||'';
        lb.showModal();
      });});
      lb.addEventListener('click',function(e){if(e.target===lb)lb.close();});
    }

    if(String.prototype.normalize) $$('[data-svd-nfkc]').forEach(function(el){el.textContent=el.textContent.normalize('NFKC');});

    update(false);
    if(root.querySelector('.svd-ok, .svd-err')){var q=root.querySelector('.svd-quote');if(q)q.scrollIntoView();}
  }
  function boot(){document.querySelectorAll('.svd').forEach(init);}
  if(document.readyState!=='loading') boot(); else document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
})();
